module.exports = __webpack_public_path__ + "assets/Hotspot-Circle-No-Plus.1cd2e13b.svg";